module.exports = __webpack_public_path__ + "media/images/shopping-cart-3546bd5c.png";